<template>
    <div>
        <!-- <div class="alert alert-danger" role="alert" v-if="showalert == true">
            <p v-if="alertmessage && alertmessage !=''" v-html="alertmessage"></p>
        </div> -->
        <div class="alert alert-danger" role="alert" v-if="store.user.deposit_count_flag > 0 && store.user.verified_status == 0 && store.user.por == 0 && forUsers">
            <p>
                {{$t("proof_residence_alert.you_have")}} {{ getPendingDate }} {{$t("proof_residence_alert.days_left_for_proof")}}
                <span v-if="store.user.profile.ticket_id">
                    <router-link :to="{ path:'/ticket-details', query : { id: store.user.profile.ticket_id }}">{{$t("proof_residence_alert.click_here")}}</router-link> {{$t("proof_residence_alert.to_upload")}}.
                </span>
            </p>
        </div>
    </div>
</template>
<script>
    import { useMainStore } from "@/store";
    export default{
        setup(){
            return {  store : useMainStore() };
        },
        data(){
            return {
                showalert:false,
                alertmessage:'',
            }
        },
        computed:{
            getPendingDate(){
                let depositdate = this.store.user.profile.payment_date
                let currentDate = new Date()
                let previousDate = new Date(depositdate)
                let timeDifference = currentDate.getTime() - previousDate.getTime()
                let daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24))
                return (daysDifference > 20 || (this.store.user.profile.is_amt_exceed == 1 && daysDifference > 2))?0:daysDifference
            },
            forUsers(){
                // return [4668].includes(this.store.user.profile.user_id) ; // dev
                return [20081,41322,40774].includes(this.store.user.profile.user_id) ; // live
            }
        },
        methods: {
        },
        created(){},
    }
</script>